import React from "react"
import { useLabels } from "../../../../../features/contents/hooks"
import Typography from "../../../../../ui/atoms/Typography"
import ExpandableMenu from "../../../../../ui/molecules/ExpandableMenu"
import { PriceRangeFilter } from "../PriceRangeFilter"

const PriceSidebarFilter = () => {
  const { getLabel } = useLabels()
  const [expanded, setExpanded] = React.useState(false)
  return (
    <ExpandableMenu
      label={
        <Typography
          variant="body1"
          weightValue={500 as any}
          textClassName="uppercase mb-2"
        >
          {getLabel("search", "price-filter")}
        </Typography>
      }
      expanded={expanded}
      onToggle={setExpanded}
      className="mt-1"
    >
      <div className="pt-6 pb-4 pl-3 pr-8">
        <PriceRangeFilter />
      </div>
    </ExpandableMenu>
  )
}

export default PriceSidebarFilter
